<template>
    <div v-if="media">
      <b-overlay
          :show="loading"
          rounded="sm">
        <b-row class="py-1 border-bottom">
          <b-col cols="2">
            <b-avatar
                v-if="media.Url && media.Url.includes('.mp4')"
                size="75px"
                rounded
                button
                @click="showInfo(media)"
            >
              <feather-icon icon="VideoIcon" size="40" />
            </b-avatar>
            <b-avatar v-else :src="media.Url" size="75px" rounded button @click="showInfo(media)" />
          </b-col>
          <b-col class="d-flex justify-content-center align-items-center">
            <b-badge style="padding: 8px">{{ enums('heroGalleryType', 'value', media.Type, 'text') }}</b-badge>
          </b-col>
          <b-col class="d-flex justify-content-center align-items-center">
            <b-dropdown right size="sm" :variant="status.badge">
              <template #button-content>
                <b-badge size="sm" style="padding: 0"  :variant="status.badge" v-text="status.text" />
              </template>
              <template>
                <b-dropdown-item
                    v-for="(status,index) in enums('heroGalleryStatus')"
                    :key="index"
                    @click="changeStatus(status)"
                >
                  {{ status.text }}
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </b-col>
          <b-col class="d-flex justify-content-end align-items-center">
            <b-button v-if="canDelete" variant="gradient-danger" class="btn-icon" size="sm" @click="deleteMedia">
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </b-col>
        </b-row>
      </b-overlay>
        <b-modal
            v-model="showMedia"
            cancel-title="بستن"
            cancel-variant="outline-secondary"
            centered
            :no-close-on-backdrop="true"
            size="md"
        >
            <video
                v-if="item.Url && item.Url.includes('.mp4')"
                style="border-radius: 0.357rem;width: 100%"
                controls
            >
                <source :src="item.Url">
            </video>
            <b-img v-else :src="item.Url" fluid-grow />
        </b-modal>
    </div>
</template>

<script>
export default {
    name: "heroGalleryItem",
    props: {
        media: { type: Object, default: null }
    },
    data() {
        return {
            loading: false,
            showMedia: false,
            status: '',
            item: {}
        }
    },
  watch: {
      media: {
        immediate: true,
        handler(val) {
          if (val) this.status = this.enums('heroGalleryStatus', 'value', val.Status)
        }
      }
  },
  computed: {
      userId() {
        return this.$route.params.id
      },
      canDelete() {
        return this.status.key === 'Rejected' || this.status.key === 'Pending'
      }
  },
  methods: {
      showInfo(item) {
        this.item = item
        this.showMedia = true
      },
      changeStatus(status) {
        this.loading = true
        const data = {
          UserId: this.userId,
          Status: status.value,
          Id: this.media.Id
        }
        this.$http.post(this.$api.hero.heroGalleryStatus, data)
          .then(() => {
            this.loading = false
            this.status = status
          })
          .finally(() => {
            this.loading = false
          })
      },
      deleteMedia() {
        const data = {
          UserId: this.userId,
          Id: this.media.Id
        }
        this.loading = true
        this.$http.post(this.$api.hero.removeHeroGallery, data)
            .then(() => {
              this.loading = false
              this.$emit('delete', this.media.Id)
            })
            .finally(() => {
              this.loading = false
            })
      }
    }
}
</script>